<template>
    <div>
        <b-modal
            id="modal-add-task"
            ref="modalAddTask"
            :lazy="true"
            title-tag="h2"
            :title="
                isEdit
                    ? isReassign
                        ? 'Reassign Task'
                        : 'Edit Task'
                    : 'New Task'
            "
            no-close-on-esc
            no-close-on-backdrop
        >
            <form class="form-horizontal">
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Task:</label>
                    <div class="col-sm-9">
                        <div
                            class="col-form-label"
                            v-if="isNotification"
                            v-html="data.task"
                        ></div>
                        <input
                            v-else
                            id="task"
                            type="text"
                            v-model="data.task"
                            v-validate="'required'"
                            :class="{ 'border-danger': errors.has('task') }"
                            name="task"
                            class="form-control"
                            placeholder="Task (required)"
                            rows="3"
                            :disabled="isReassign"
                        />
                    </div>
                </div>
                <div class="form-group row" v-if="isEdit">
                    <label class="col-sm-3 col-form-label">Status:</label>
                    <div class="col-sm-9">
                        <select
                            name="status"
                            v-model="data.status"
                            class="form-control"
                            :disabled="isReassign"
                        >
                            <option :value="0">Open</option>
                            <option :value="2">In Progress</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Priority:</label>
                    <div class="col-sm-9">
                        <select
                            name="applyTo"
                            v-model="data.priority"
                            class="form-control"
                            :disabled="isReassign"
                        >
                            <option :value="0">
                                Normal
                            </option>
                            <option :value="1">High</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">{{
                        module == "patient" ? "Assign To:" : "Staff:"
                    }}</label>
                    <div class="col-sm-9">
                        <v-select
                            id="staffs"
                            ref="vselect"
                            v-validate="'required'"
                            :class="{ 'border-danger': errors.has('staffs') }"
                            :options="staff_options_exclude"
                            v-model="data.staffs"
                            :label="'fullname'"
                            :selectable="option => option.type != 'divider'"
                            name="staffs"
                            multiple
                            aria-placeholder="true"
                            placeholder="Assign to (required)"
                            ><template slot="option" slot-scope="option">
                                <hr
                                    v-if="option.type === 'divider'"
                                    class="divider"
                                    style="margin: 0;"
                                />
                                <template v-else>{{
                                    option.fullname
                                }}</template>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Due:</label>
                    <div class="col-sm-9">
                        <div v-if="isReassign" class="d-flex">
                            <input
                                type="text"
                                :value="getDate(data.due)"
                                class="form-control mr-2"
                                disabled
                            />
                            <input
                                type="text"
                                :value="getTime(data.due)"
                                class="form-control"
                                disabled
                            />
                        </div>
                        <vet-datetime
                            v-else
                            v-model="data.due"
                            v-validate="'required'"
                            :placeholder="{
                                date: 'Date (required)',
                                time: 'Time (required)'
                            }"
                            :inner-class="{
                                'border-danger': errors.has('due')
                            }"
                            rules="required"
                            container="#modal-add-task"
                            name="due"
                        ></vet-datetime>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Contact:</label>
                    <div class="col-sm-9">
                        <input
                            v-if="isReassign"
                            type="text"
                            :value="data.client ? data.client.label : null"
                            class="form-control"
                            disabled
                        />
                        <v-select
                            v-else
                            v-model="data.client"
                            :options="clientOptions"
                            @search="searchClientContacts"
                            placeholder="Client/Contact (optional)"
                            :clearSearchOnBlur="() => false"
                            label="label"
                        >
                            <template slot="no-options">
                                <span v-if="searchClient.length == 0"
                                    >Please enter 2 or more characters</span
                                >
                                <span v-if="searchClient.length == 1"
                                    >Please enter 1 or more characters</span
                                >
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Patient:</label>
                    <div class="col-sm-9">
                        <input
                            v-if="isReassign"
                            type="text"
                            :value="data.patient ? data.patient.name : null"
                            class="form-control"
                            disabled
                        />
                        <vet-select
                            v-else
                            id="patient_id"
                            v-model="data.patient"
                            :client-id="data.client_id"
                            :disabled="disablePatientSelect"
                            :options="poptions"
                            :show-menu="false"
                            module="client-patient-all"
                            placeholder="Patient (optional)"
                            label="name"
                            name="patient_id"
                            ref="selectClientPatient"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Item(s):</label>
                    <div class="col-sm-9">
                        <input
                            v-if="isReassign"
                            type="text"
                            :value="data.items ? getItems(data.items) : null"
                            class="form-control"
                            disabled
                        />
                        <v-select
                            v-else
                            v-model="data.items"
                            :options="items_options_exclude"
                            @search="searchItems"
                            @input="itemSelected"
                            placeholder="Item(s) (optional)"
                            label="display_name"
                            multiple
                        >
                            <template slot="no-options">
                                <span v-if="search.length == 0"
                                    >Please enter 3 or more characters</span
                                >
                                <span v-if="search.length == 1"
                                    >Please enter 2 or more characters</span
                                >
                                <span v-if="search.length == 2"
                                    >Please enter 1 or more characters</span
                                >
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Repeat:</label>
                    <div class="col-sm-9">
                        <select
                            v-model="data.repeat"
                            :value="1"
                            v-validate="'required'"
                            name="repeat"
                            class="form-control"
                            aria-invalid="false"
                            :disabled="isReassign"
                        >
                            <option value="1">Does not repeat</option>
                            <option value="2"
                                >Every day (Monday - Sunday)</option
                            >
                            <option value="3"
                                >Every weekday (Monday - Friday)</option
                            >
                            <option value="4"
                                >Every weekend (Saturday - Sunday)</option
                            >
                            <option value="5"
                                >Every Monday, Wednesday, Friday</option
                            >
                            <option value="6"
                                >Every Tuesday and Thursday</option
                            >
                            <option value="7">Every Week</option>
                            <option value="10">Every 2 Weeks</option>
                            <option value="11">Every 3 Weeks</option>
                            <option value="12">Every 4 Weeks</option>
                            <option value="8">Every Month</option>
                            <option value="9">Every Year</option>
                            <option value="13">Custom</option>
                        </select>
                    </div>
                </div>
                <div
                    v-if="data.repeat > 1 && data.repeat != 13"
                    class="form-group row"
                >
                    <label class="col-sm-3 col-form-label" for="stop"
                        >Occurrence:</label
                    >
                    <div class="col-sm-9">
                        <input
                            :class="{ 'border-danger': errors.has('stop') }"
                            v-model="data.stop"
                            v-validate="{
                                required: data.repeat > 1,
                                numeric: data.repeat > 1
                            }"
                            type="number"
                            min="0"
                            step="1"
                            class="form-control"
                            placeholder="Occurrence (required)"
                            name="stop"
                            :disabled="isReassign"
                        />
                    </div>
                </div>
                <div v-if="data.repeat == 13" class="form-group row">
                    <label class="col-sm-3 col-form-label" for="stop"
                        >Occurrence:</label
                    >
                    <div class="col-sm-9 d-flex align-items-center">
                        <div
                            class="d-flex align-items-center justify-content-center"
                        >
                            <input
                                :class="{ 'border-danger': errors.has('stop') }"
                                v-model="data.stop"
                                v-validate="{
                                    required: data.repeat > 1,
                                    numeric: data.repeat > 1
                                }"
                                type="number"
                                min="0"
                                step="1"
                                class="form-control width50px"
                                placeholder="Occurrence (required)"
                                name="stop"
                                :disabled="isReassign"
                            />
                            <span class="ml-2 mr-2">times every</span>
                        </div>
                        <div class="px-0 mr-1">
                            <input
                                v-model="data.specific_interval"
                                type="number"
                                min="1"
                                max="99"
                                step="1"
                                class="form-control"
                                :class="{
                                    'border-danger': errors.has(
                                        'specific_interval'
                                    )
                                }"
                                name="specific_interval"
                                :disabled="isReassign"
                                style="width: 3.5rem;"
                            />
                        </div>

                        <b-form-select
                            id="repeat_interval"
                            v-model="data.repeat_interval"
                            :options="repeatIntervalOptions"
                            :value="'days'"
                            name="repeat_interval"
                            class="form-control custom-select col-4"
                            style="width: 8.1rem;"
                            :disabled="isReassign"
                        ></b-form-select>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Notes:</label>
                    <div class="col-sm-9">
                        <textarea
                            v-if="isReassign"
                            v-html="data.notes"
                            class="form-control"
                            disabled
                        ></textarea>
                        <editable
                            v-else
                            id="notes"
                            ref="task-notes"
                            :value.sync="data.notes"
                        ></editable>
                    </div>
                </div>

                <div class="form-group row" v-if="isEdit && data.repeat > 1">
                    <label class="col-sm-3 col-form-label">Apply To:</label>
                    <div class="col-sm-9">
                        <select
                            name="applyTo"
                            v-model="applyTo"
                            class="form-control"
                        >
                            <option value="1">
                                Only this task
                            </option>
                            <option value="2">This and following tasks</option>
                            <option value="3">All events</option>
                        </select>
                    </div>
                </div>
            </form>
            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs.modalAddTask.hide()"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button
                        v-else-if="isEdit || isReassign"
                        @click="saveTask()"
                        class="float-right"
                        variant="primary"
                        >Save</b-button
                    >
                    <b-button
                        v-else-if="isNotification"
                        variant="primary"
                        @click="saveTask(false)"
                    >
                        Save + Done
                    </b-button>
                    <b-button-group v-else>
                        <b-dropdown
                            v-if="!continues"
                            @click="saveTask(false)"
                            left
                            split
                            text="Save + Done"
                            variant="primary"
                        >
                            <b-dropdown-item @click="saveTask(true)"
                                >Save + Add New</b-dropdown-item
                            >
                        </b-dropdown>
                        <b-dropdown
                            v-else
                            @click="saveTask(true)"
                            left
                            split
                            text="Save + Add New"
                            variant="primary"
                        >
                            <b-dropdown-item @click="saveTask(false)"
                                >Save + Done</b-dropdown-item
                            >
                        </b-dropdown>
                    </b-button-group>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import vetSelect from "@/module/commons/vet-select.vue";
import { difference, differenceWith, assign, debounce } from "lodash";
import vSelect from "vue-select";
import vetDatetime from "@/module/commons/date-time-picker.vue";
import Items from "@/services/items";
import Tasks from "@/services/client-tasks";
import { DateTime } from "luxon";
import Editable from "@/components/elements/editable";

export default {
    components: {
        vSelect,
        vetDatetime,
        Editable,
        vetSelect
    },
    props: {
        currentClient: {
            type: Object
        },
        patientDetails: {
            type: Object
        },
        isEdit: {
            type: Boolean,
            default: false
        },
        isReassign: {
            type: Boolean,
            default: false
        },
        module: {
            type: String,
            required: false
            // validator: function (value) {
            //     // The value must match one of these strings
            //     return ["patient", "client"].includes(value.toLowerCase());
            // }
        },
        isNotification: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data() {
        return {
            data: {
                staffs: {},
                items: null,
                due: null,
                client: null,
                client_id: null,
                patient: null,
                patient_id: null,
                repeat: 1,
                stop: 1,
                task: null,
                notes: null,
                status: 0,
                priority: 0,
                specific_interval: 1,
                repeat_interval: 1
            },
            applyTo: "1",
            search: "",
            continues: false,
            staffRoleList: [],
            staffList: [],
            roleList: [],
            poptions: [],
            itemOptions: [],
            loading: false,
            datePickerOptions: {
                format: "DD/MM/YYYY"
            },
            repeatIntervalOptions: [
                { value: 1, text: "Day(s)" },
                { value: 2, text: "Week(s)" },
                { value: 3, text: "Month(s)" },
                { value: 4, text: "Year(s)" }
            ],
            notificationItem: {
                id: null,
                type: null
            },
            clientOptions: [],
            searchClient: ""
        };
    },
    computed: {
        staff_options_exclude() {
            let combine = this.staffList.concat(
                [{ type: "divider" }],
                this.roleList
            );
            return difference(combine, this.data.staffs);
        },
        items_options_exclude() {
            return differenceWith(
                this.itemOptions,
                this.data.items,
                (itemA, itemB) => itemA.id == itemB.id
            );
        },
        selectedTask() {
            return this.$store.getters["task/selected"];
        },
        disablePatientSelect() {
            if (this.isNotification) {
                if (this.data.patient) {
                    return false;
                }
                return true;
            } else {
                return !this.data.client_id;
            }
        }
    },
    watch: {
        "data.client": {
            handler(newData, oldData) {
                let self = this;
                self.data.client_id = newData ? newData.id : null;
                self.data.type = newData ? 0 : 1;
                self.poptions = [];

                if (newData) {
                    // -- change to other client
                    if (oldData && oldData != newData) {
                        this.data.client_changed = 1;
                        self.data.patient = null;
                    } else {
                        this.data.client_changed = 0;
                    }
                } else {
                    this.poptions = [];
                    this.data.patient_id = null;
                    this.data.patient = null;
                }
            }
        },
        "data.patient": {
            handler(newData, oldData) {
                if (newData) {
                    this.data.patient_id = newData.id;
                } else {
                    this.data.patient_id = null;
                }

                if (oldData && oldData != newData) {
                    this.data.patient_changed = 1;
                }
            }
        }
    },
    mounted() {},
    methods: {
        open(params = {}) {
            this.$nextTick(() => {
                this.getStaffList();
                this.getRoleList();
                this.setDate();
                this.setStaffs();
                this.setItems();
                this.setRepeat();
                this.setContent(params.task);
                this.setPatient();
                this.setClient();
                this.setPriority();
                this.setNotes();

                if (this.isEdit) {
                    this.data.status = this.selectedTask.status;
                }
            });

            if (this.isNotification) {
                this.notificationItem.id = params.notificationId;
                this.notificationItem.type = params.notificationType;
                this.applyMetadataNotification(params);
            }

            this.$refs.modalAddTask.show();
        },
        applyMetadataNotification(params = {}) {
            if (params?.metadata?.patient) {
                this.data.patient = {
                    id: params.metadata.patient.id,
                    name: params.metadata.patient.name
                };
            }

            if (params?.metadata?.client) {
                this.data.client = {
                    id: params.metadata.client.id,
                    label: params.metadata.client.name + " (client)"
                };
            } else if (params?.metadata?.contact) {
                this.data.client = {
                    id: params.metadata.contact.id,
                    label: params.metadata.contact.name + " (contact)"
                };
            }
        },
        setNotes() {
            if (this.isEdit || this.isReassign) {
                this.data.notes = this.selectedTask.note;
            }
        },
        setPriority() {
            if (this.isEdit || this.isReassign) {
                this.data.priority = this.selectedTask.priority;
            }
        },
        setDate() {
            this.datePickerOptions.format = this.getDateFormat();
            if (this.isEdit || this.isReassign) {
                this.data.due = DateTime.fromISO(this.selectedTask.iso_date, {
                    zone: this._timeZone
                });
            } else {
                this.data.due = this._now();
            }
        },
        setStaffs() {
            if (this.isEdit || this.isReassign) {
                this.data.staffs = [];
                this.selectedTask.assign_to_staffs.forEach(element => {
                    this.data.staffs.push({
                        id: "S-" + element.staffId,
                        fullname: element.staffName,
                        fullId: element.staffId
                    });
                });

                this.selectedTask.assign_to_roles.forEach(element => {
                    this.data.staffs.push({
                        id: "R-" + element.id,
                        fullname:
                            element.roleName + " (" + element.staff_count + ")"
                    });
                });
            } else {
                this.data.staffs = [
                    {
                        id: "S-" + this.$root.currentActor.id,
                        fullname: this.$root.currentActor.fullname,
                        fullId: this.$root.currentActor.id
                    }
                ];
            }
        },
        setClient() {
            let clientContact =
                this.isEdit || this.isReassign
                    ? this.selectedTask.client
                    : this.currentClient;
            if (clientContact) {
                this.data.client = {
                    id: clientContact.id,
                    label:
                        clientContact.firstname +
                        " " +
                        clientContact.lastname +
                        " " +
                        `(${
                            clientContact.with_type ??
                            (this.module === "contact" ? "contact" : "client")
                        })`
                };
            }
        },
        setPatient() {
            if (this.isEdit || this.isReassign) {
                let patient = this.selectedTask.patient;

                if (patient) {
                    this.data.patient = {
                        id: patient.id,
                        name: patient.name
                    };
                }
            } else if (this.patientDetails) {
                this.data.patient = {
                    id: this.patientDetails.id,
                    name: this.patientDetails.name
                };
            }
        },
        setItems() {
            if (this.isEdit || this.isReassign) {
                this.data.items = [];
                let items = this.selectedTask.task_profile
                    ? this.selectedTask.task_profile.items
                    : [];

                items.forEach(element => {
                    this.data.items.push({
                        id: element.id,
                        display_name: element.name
                    });
                });
            }
        },
        setRepeat() {
            if (this.isEdit || this.isReassign) {
                if (this.selectedTask.task_profile) {
                    this.data.repeat = this.selectedTask.task_profile.repeat_every;
                    this.data.stop = this.selectedTask.task_profile.occurrence;
                }
            }
        },
        setContent(task = "") {
            if (this.isEdit || this.isReassign) {
                this.data.task = this.selectedTask.content;
            } else if (this.isNotification) {
                this.data.task = task;
            } else {
                this.data.task = null;
            }
        },
        searchItems(search) {
            let params = search;
            let self = this;

            self.search = search;

            if (!search) {
                self.itemOptions = [];
            }

            if (search && search.length > 2) {
                return this.searchItemsResource(params);
            }
        },
        itemSelected(event) {
            let self = this;
            if (event && event.length < 1) {
                return;
            }
            if (self.data.items.length > 1 && self.itemOptions.length) {
                return;
            }
            let params = "";
            return this.searchItemsResource(params);
        },
        async searchItemsResource(keys) {
            let self = this;
            let params = {
                page: 1,
                exclude_ids: null,
                search_key: keys
            };

            let response = await Items.getItems(params);

            if (response) {
                self.itemOptions = response;
            } else {
                self._message(response.message.errors, "danger");
            }
            return response;
        },
        getStaffList() {
            let self = this;
            return this.$http
                .get(process.env.ACTOR_SERVICE + "staff?getAll=1")
                .then(function (response) {
                    if (response.data.response.resources) {
                        self.staffList = [];
                        response.data.response.resources.forEach(element => {
                            self.staffList.push({
                                id: "S-" + element.id,
                                fullId: element.id,
                                fullname:
                                    element.firstname +
                                    " " +
                                    (element.lastname
                                        ? element.lastname
                                              .substring(0, 1)
                                              .concat(".")
                                        : "")
                            });
                        });
                    }
                    return self.staffList;
                });
        },
        getRoleList() {
            let self = this;
            return this.$http
                .get(process.env.ACTOR_SERVICE + "roles")
                .then(function (response) {
                    if (response.data.response.resources.length > 0) {
                        self.roleList = [];
                        response.data.response.resources.forEach(element => {
                            if (element.staff_count > 0) {
                                self.roleList.push({
                                    id: "R-" + element.id,
                                    fullname:
                                        element.name +
                                        " (" +
                                        element.staff_count +
                                        ")"
                                });
                            }
                        });
                    }
                });
        },
        getDate(date) {
            return DateTime.fromISO(date, { zone: this._timeZone }).toFormat(
                "dd/LL/yyyy"
            );
        },
        getTime(date) {
            return DateTime.fromISO(date, { zone: this._timeZone }).toFormat(
                "hh:mm a"
            );
        },
        getItems(items) {
            let list = "";
            items.forEach(function (item, i) {
                if (i != 0) list += ", ";
                list += item.display_name;
            });
            return list;
        },
        dateChange(event, element) {
            this.data[element] = event.date;
        },
        convertDateTimeToISO(date, time) {
            if (DateTime.isDateTime(time)) {
                time = time.toFormat("hh:mm a");
            }

            let dateTimeStr = `${date} ${time}`;
            let format = `${this.dateTimeFormat.date.luxon} ${this.dateTimeFormat.time.luxon}`;

            // from user's timezone to UTC, and format as ISO
            let result = DateTime.fromFormat(dateTimeStr, format, {
                zone: this._timeZone
            }).toISO({
                suppressMilliseconds: true
            });

            return result;
        },
        async saveTask(continues) {
            this.loading = true;
            let valid = await this.$validator.validateAll();
            if (!valid) {
                this.loading = false;
                return;
            }
            let staffArr = [];
            let roleArr = [];
            this.data.staffs.forEach(element => {
                let arr = element.id.split("-");
                if (arr[0] === "S") staffArr.push({ id: element.fullId });
                if (arr[0] === "R") roleArr.push({ id: arr[1] });
            });

            let itemArr = [];
            if (this.data.items) {
                this.data.items.forEach(element => {
                    itemArr.push({ id: element.id });
                });
            }
            let properDate = this.data.due.set({ milliseconds: 0 }).toISO({
                suppressMilliseconds: true
            });

            let params = {
                task: this.data.task,
                staffs: staffArr,
                roles: roleArr,
                timezone: this._timeZone,
                due: properDate,
                patientId: this.data.patient_id,
                clientId: this.data.client_id,
                items: itemArr,
                repeatEvery: this.data.repeat,
                occurrence: this.data.stop ? Number(this.data.stop) : "",
                priority: this.data.priority,
                note: this.data.notes,
                status: this.data.status,
                notification_id: this.notificationItem?.id
            };

            if (this.data.repeat == 13 || this.data.repeat == "13") {
                params.specific_interval = this.data.specific_interval;
                params.repeat_interval = this.data.repeat_interval;
            }

            if (this.isEdit || this.isReassign) {
                params.id = this.selectedTask.id;
                params.applyTo = this.applyTo;

                this.editTaskDetails(params);
            } else {
                this.createNewTask(params, continues);
            }
        },
        createNewTask(params, continues) {
            Tasks.createTask(params)
                .then(response => {
                    if (response && response.message.code === 200) {
                        this._message(response.resource.message);

                        if (continues) {
                            assign(this.$data, this.$options.data());
                            this.open();
                            this.$validator.reset();
                            this.continues = true;
                            this.setDate(); //put here to trigger after the date been reset as its function in this.open() not working very well
                        } else {
                            this.$refs.modalAddTask.hide();
                        }
                        this.updateTaskView(response.resource.data);

                        if (this.isNotification) {
                            this.$emit("reload", {
                                id: this.notificationItem.id,
                                type: this.notificationItem.type,
                                isModalTask: true
                            });
                        } else {
                            this.$emit("reload", response.resource.data);
                        }

                        this.$socket.client.emit("v-broadcast", {
                            businessId: this.$root.setting.business_id,
                            action: "refresh-task-list",
                            record: response?.resource?.data
                        });
                    } else {
                        this._message(response.message, "danger");
                    }
                })
                .catch(error => {
                    console.error(error);
                    this._message("Error saving data", "danger");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        editTaskDetails(params) {
            Tasks.updateTask(params)
                .then(response => {
                    if (response && response.message.code === 200) {
                        this._message(response.resource.message);
                        this.$refs.modalAddTask.hide();
                        this.$emit("reload");

                        // note on update task callback:
                        // previously, we used emit(reload) to refresh the task list and task details.
                        // after VET-7099, we will use socket to trigger the refresh for the list and details.
                        // we use the socket to apply it to all the involved assignees (multiple people if any).
                        // The socket action keyword for search is: "task-updated".
                    } else {
                        this._message(response.message, "danger");
                    }
                })
                .catch(error => {
                    console.error(error);
                    this._message("Error saving data", "danger");
                });
        },
        updateTaskView(details) {
            if (this.$router.currentRoute.name === "tasks") {
                this.$store.dispatch("task/getTaskDetails", details.id);
                this.$root.$emit("task-header-clear-search");
                this.changeDate(this._carbonDateDisplay(details.date)).then(
                    () => {
                        this.$root.$emit("task-list:refresh");
                    }
                );
            }
        },
        async changeDate(date) {
            this.$store.commit("task/setDate", date);
        },
        async save(continues) {
            let self = this;
            let valid = await this.$validator.validateAll();
            if (!valid) {
                return false;
            }

            self.loading = true;

            let assign_tos = "";
            $.each(self.data.staffs, function (index, value) {
                assign_tos += value.id + ",";
            });

            let item_ids = "";
            $.each(self.data.items, function (index, value) {
                item_ids += value.id + ",";
            });

            let post = {
                id:
                    this.isEdit || this.isReassign
                        ? this.selectedTask.id
                        : null,
                cid: self.data.client_id,
                pid: self.data.patient_id,
                client: self.data.client ? self.data.client : null,
                patient: self.data.patient ? self.data.patient.name : null,
                date: self.data.due.toFormat(self._getLuxonFormat()),
                time: self.data.due.toFormat("h:mm a"),
                repeat_every: self.data.repeat,
                occurrence: self.data.stop,
                content: self.data.task,
                assign_tos: assign_tos,
                item_ids: item_ids,
                apply_to: this.applyTo,
                priority: self.data.priority === 1
            };

            const response = await $.post(
                process.env.APPS + "index.php/schedule/task/save",
                post
            );

            // -- print letter
            if (response && response.state == 0) {
                self._message(response.message);
                if (continues) {
                    assign(this.$data, this.$options.data());
                    this.open();
                    this.$validator.reset();
                    this.continues = true;
                    this.setDate(); //put here to trigger after the date been reset as its function in this.open() not working very well
                } else {
                    this.$refs.modalAddTask.hide();
                }
                this.$emit("reload");
                // this._taskCheck();
            } else {
                self._message(response.message, "danger");
                self.loading = false;
            }

            await this.$store.commit("task/unSetSelectedTask");
            return response;
        },
        searchClientContacts: debounce(function (search) {
            let self = this;
            self.searchClient = search;
            if (search && search.length > 1) {
                this.searchClientContactsResource(search);
            } else {
                self.clientOptions = [];
            }
        }, 350),
        async searchClientContactsResource(search) {
            let self = this;
            let response = await Tasks.searchClientContacts(search);
            if (response) {
                self.clientOptions = response;
            } else {
                self._message(response.message.errors, "danger");
            }
        }
    }
};
</script>
<style type="text/css">
#modal-add-task #editable-div {
    height: 70px;
}

.width50px {
    min-width: 50px;
    max-width: 50px;
}
</style>
